import React from "react";
import { CheckIcon } from "./icons";

/**
 * Multi-select toggle chips (E §8 — LOB picker). 44px touch targets,
 * chips not checkboxes. options: [{ value, label }]; value: string[].
 */
function ChipToggle({ options, value, onChange, "aria-label": ariaLabel }) {
  const toggle = (v) => {
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  };
  return (
    <div className="fk-chips" role="group" aria-label={ariaLabel}>
      {options.map((opt) => {
        const on = value.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            className={`fk-chip${on ? " fk-chip--on" : ""}`}
            aria-pressed={on}
            onClick={() => toggle(opt.value)}
          >
            {on ? <CheckIcon size={12} /> : null}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default ChipToggle;
